/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ContentLocation,
  ContentReferencesStats,
  ContentReferenceUsage,
  List,
  Revision,
  RevisionFile,
  RevisionPage,
  RevisionPageDocument,
  RevisionPageGroup,
  RevisionPageMetaLinks,
  RevisionReusableContent,
  RevisionSemanticChanges,
} from "./data-contracts";

/**
 * No description
 * @tags change-request-content
 * @name GetRevisionOfChangeRequestById
 * @summary Get a change request the latest content revision
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content
 * @secure
 */

// @ts-ignore
export const getRevisionOfChangeRequestById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Revision;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name ListPagesInChangeRequest
 * @summary List all change request pages
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/pages
 * @secure
 */

// @ts-ignore
export const listPagesInChangeRequest: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/pages",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name ListFilesInChangeRequestById
 * @summary List all change request files
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/files
 * @secure
 */

// @ts-ignore
export const listFilesInChangeRequestById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: RevisionFile[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/files",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name GetFileInChangeRequestById
 * @summary Get a change request file by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}
 * @secure
 */

// @ts-ignore
export const getFileInChangeRequestById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the file */
    fileId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionFile;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name ListChangeRequestFileBacklinks
 * @summary List all backlink locations of a change request file
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}/backlinks
 * @secure
 */

// @ts-ignore
export const listChangeRequestFileBacklinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the file */
    fileId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContentLocation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}/backlinks",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name GetPageInChangeRequestById
 * @summary Get a change request page by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}
 * @secure
 */

// @ts-ignore
export const getPageInChangeRequestById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPage;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content, critical
 * @name ListPageLinksInChangeRequest
 * @summary List all change request links
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/links
 * @secure
 */

// @ts-ignore
export const listPageLinksInChangeRequest: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    stats: ContentReferencesStats;
    items: ContentReferenceUsage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/links",
  method: "get",
  streaming: false,
  tags: ["change-request-content", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name ListChangeRequestPageBacklinks
 * @summary List all backlink locations of a change request page
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/backlinks
 * @secure
 */

// @ts-ignore
export const listChangeRequestPageBacklinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContentLocation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/backlinks",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name ListChangeRequestPageMetaLinks
 * @summary List all meta links of a change request page
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/meta-links
 * @secure
 */

// @ts-ignore
export const listChangeRequestPageMetaLinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageMetaLinks;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/meta-links",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name GetReusableContentInChangeRequestById
 * @summary Get a change request reusable content by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/reusable-contents/{reusableContentId}
 * @secure
 */

// @ts-ignore
export const getReusableContentInChangeRequestById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the reusable content */
    reusableContentId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionReusableContent;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/reusable-contents/{reusableContentId}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Return the semantic changes between a change request and its base revision.
 * @tags change-request-content
 * @name GetChangeRequestChanges
 * @summary Get change request semantic changes
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/changes
 * @secure
 */

// @ts-ignore
export const getChangeRequestChanges: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /**
     * Limit the number of changes returned
     * @default 10
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionSemanticChanges;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/changes",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-content
 * @name GetPageInChangeRequestByPath
 * @summary Get a change request page by its path
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/path/{pagePath}
 * @secure
 */

// @ts-ignore
export const getPageInChangeRequestByPath: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The path of the page in the revision. */
    pagePath: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageDocument | RevisionPageGroup;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/path/{pagePath}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  criticalityLevel: "low",
  deprecated: false,
};
